import { useContext } from "react";
//import { ViewerContext } from "../../Context/ViewerContext/ViewerContextProvider";
import { XktContext } from "../../Context/XktContext/XktContextProvider";
//import { setHighlightedEntities } from "../../Context/ViewerContext/Reducer";


const useFlyTo = () => {
    //const { state: viewerState, dispatch } = useContext(ViewerContext);
    const { state } = useContext(XktContext);
    const flyTo = async (elements: string[], aabb?: number[]) => {
        if (!state.viewer) return;
        const elementAabb = aabb ? aabb : state.viewer.scene.getAABB(elements);
        //const highlighted = viewerState.highlightedEntities;
        state.viewer.cameraFlight.flyTo({ aabb: elementAabb });
        // for (let i = 0; i < 5; i++) {
        //     dispatch(setHighlightedEntities(elements));
        //     await new Promise((resolve) => setTimeout(resolve, 200));
        //     dispatch(setHighlightedEntities([]));
        //     await new Promise((resolve) => setTimeout(resolve, 200));
        // }
        // dispatch(setHighlightedEntities(highlighted));
    }

    return { flyTo };
}
export default useFlyTo;